module.exports = __webpack_public_path__ + "static/media/project-icon-playlist.a99ca892.png";